import React, { useState, useRef, useEffect } from 'react';
import { Layout, Input, Button, Spin, Avatar, List, Divider, Card, message } from 'antd';
import { SendOutlined, UserOutlined, RobotOutlined } from '@ant-design/icons';
import { useAuth } from '../hooks/useAuth';
import { useQianfangChat } from '../context/QianfangChatContext';
import ReactMarkdown from 'react-markdown';

const { Content, Header } = Layout;
const { TextArea } = Input;

const QianfangChat = () => {
  const { user } = useAuth();
  const { 
    messages, 
    loading, 
    sendChatMessage,
    createSession
  } = useQianfangChat();
  const [input, setInput] = useState('');
  const messagesEndRef = useRef(null);

  // 确保在页面加载时有初始消息
  useEffect(() => {
    if (messages.length === 0) {
      createSession();
    }
  }, [messages.length, createSession]);

  // 自动滚动到最新消息
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // 处理发送消息
  const handleSendMessage = async () => {
    if (!input.trim()) return;
    
    const userInput = input.trim();
    setInput('');
    
    try {
      await sendChatMessage(userInput);
    } catch (error) {
      message.error('发送消息失败，请重试');
    }
  };

  // 处理键盘事件
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <Layout className="layout" style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#1890ff' }}>
        <div className="logo" style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>
          千方智能问答
        </div>
        <div style={{ color: 'white' }}>
          智能问答
        </div>
      </Header>
      
      <Content style={{ padding: '10px', display: 'flex', flexDirection: 'column', height: 'calc(100vh - 64px)' }}>
       
        <Card 
          style={{ 
            flex: 1, 
            display: 'flex', 
            flexDirection: 'column', 
            overflow: 'hidden',
            marginBottom: '10px'
          }}
          bodyStyle={{ 
            flex: 1, 
            display: 'flex', 
            flexDirection: 'column', 
            padding: '20px',
            overflow: 'hidden'
          }}
        >
          
          <div style={{ flex: 1, overflow: 'auto', paddingRight: '5px' }}>
            <List
              itemLayout="horizontal"
              dataSource={messages}
              renderItem={(message) => (
                <List.Item style={{ padding: '10px 0' }}>
                  <List.Item.Meta
                    avatar={
                      message.role === 'assistant' 
                        ? <Avatar icon={<RobotOutlined />} style={{ backgroundColor: '#1890ff' }} /> 
                        : <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#52c41a' }} />
                    }
                    title={message.role === 'assistant' ? '千方智能助手' : user?.name || '您'}
                    description={
                      <div style={{ whiteSpace: 'pre-wrap' }}>
                        {message.temporary ? (
                          <Spin size="small" style={{ marginRight: '10px' }} />
                        ) : (
                          <div className="markdown-content" style={{ lineHeight: '1.3' }}>
                            <ReactMarkdown>{message.content}</ReactMarkdown>
                          </div>
                        )}
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
            <div ref={messagesEndRef} />
          </div>
          
          <Divider style={{ margin: '10px 0' }} />
          
          <div style={{ display: 'flex', marginTop: '10px' }}>
            <TextArea
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="请输入您的问题..."
              autoSize={{ minRows: 2, maxRows: 4 }}
              disabled={loading}
              style={{ flex: 1, marginRight: '10px' }}
            />
            <Button 
              type="primary" 
              icon={<SendOutlined />} 
              onClick={handleSendMessage} 
              loading={loading}
            >
              发送
            </Button>
          </div>
        </Card>
      </Content>
    </Layout>
  );
};

export default QianfangChat; 